/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const humanFileSize = (size, si = false, dp = 0) => {
  let bytes = size;
  const thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }
  const units = [
    'kB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
  ];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    // eslint-disable-next-line no-plusplus
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  return `${bytes.toFixed(dp)} ${units[u]}`;
};

export function preventAlphaInput(event) {
  const spaceBar = 32;
  const numPadBegin = 96;
  const numPadEnd = 105;
  const charCode = typeof event.which === 'undefined' ? event.keyCode : event.which;
  if (!event.ctrlKey) {
    if (charCode === spaceBar) {
      event.preventDefault();
    }

    if ((charCode > 57 && charCode < numPadBegin) || charCode > numPadEnd) {
      event.preventDefault();
    }
  }
}

const specialCharacters = '.,<>=_"-()/|';

export function preventSpecialCharsAtBeginningInput(event) {
  if ((event.target.value === undefined || event.target.value.length === 0) && specialCharacters.includes(event.key)) {
    event.preventDefault();
  }
}

export function preventSpecialCharsAtBeginningInputOnPaste(event) {
  const data = event.clipboardData.getData('Text');
  if (data !== undefined && data.length > 0 && specialCharacters.includes(data.substring(0, 1))) {
    event.preventDefault();
  }
}

export function preventAlphaInputOnPaste(event) {
  const data = event.clipboardData.getData('Text');
  if (data.match(/[^\d]/)) {
    event.preventDefault();
  }
}

export function removeLeadingZeros(event) {
  event.target.value = event.target.value.replace(/^0+/, ''); // eslint-disable-line no-param-reassign
}

export function filterNumbers(event) {
  // eslint-disable-next-line no-param-reassign
  event.target.value = event.target.value.replace(/\D/g, '');
}

export function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export function capitalizeWords(str) {
  if (typeof str !== 'string') return '';
  return str.replace(/\b\w/g, function(match) {
    return match.toUpperCase();
  });
}

export function removeSpecialCharacters(s) {
  if (typeof s !== 'string') return '';
  return s.replace(/[^a-zA-Z0-9]/g, ' ');
}

export function removeLeadingWhitespace(event) {
  event.target.value = event.target.value.replace(/^\s+/, ''); // eslint-disable-line no-param-reassign
}

export function removeLeadingWhitespaceForValue(value) {
  return value?.replace(/^\s+/, '');
}

export function singularize(word) {
  if (word) return word.replace(/^(.+)s$/g, '$1');
  return word;
}

export function trimToSize(s, size) {
  if (typeof s !== 'string') return '';
  if (s.length < size + 3) return s;
  return `${s.substring(0, size)}...`;
}

export function twoDecimalsFormatter(locale) {
  return Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const toEllipsis = (string, maxLength) => {
  if (string.length > maxLength) {
    return `${string.slice(0, maxLength)}...${string.slice(-4)}`;
  }
  return string;
};

export const checkTitleAndRemoveWhitespaces = (title, label = 'noTitle') =>
  typeof title === 'string' ? title.replace(/ /g, '') : label;
